import * as types from './types';
import _ from 'lodash';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  customQueryCategoryListData: [],
  fetchingCustomQueryCategory: false,
  customQueryCategoryListError: null,
  customQueryDataError: null,
  loading: false,
  customQueryData: [],
  categoryDeleteSuccess: false,
  categoryDeleteError: null,
  categorySaveSuccess: false,
  categorySaveError: null,
  querySaveError: null,
  queryDownloadError: false,
  queryExecuteSuccess: false,
  queryExecuteError: false,
  customQueryDownloadError: null,
  customQueryDeleteError: null,
  customQueryDeleteSuccess: false,
  customQueryCategoryDeleteSuccess: false,
  customQuerySaveSuccess: false,
  newCategory: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CUSTOM_QUERY_CATEGORY_LOADING: {
      return {
        ...state,
        fetchingCustomQueryCategory: action.payload,
      };
    }

    case types.CUSTOM_QUERY_CATEGORY_LIST: {
      return {
        ...state,
        customQueryCategoryListData: action.payload,
      };
    }

    case types.CUSTOM_QUERY_CATEGORY_LIST_ERROR:
      const customCategoryListResponse = action.payload.response;
      if (
        _.has(customCategoryListResponse, 'data.Errors') &&
        customCategoryListResponse.data.Errors.length
      ) {
        return {
          ...state,
          customQueryCategoryListError:
            customCategoryListResponse.data.Errors.length > 1
              ? customCategoryListResponse.data.Errors
              : customCategoryListResponse.data.Errors[0],
        };
      }
      return {
        ...state,
        customQueryCategoryListError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching category list. Please try again.',
        },
      };

    case types.CUSTOM_QUERY_DATA_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.CUSTOM_QUERY_DATA_LIST: {
      return {
        ...state,
        customQueryData: action.payload,
      };
    }

    case types.CUSTOM_QUERY_DATA_ERROR:
      const customQueryErrorResponse = action.payload.response;
      if (
        _.has(customQueryErrorResponse, 'data.Errors') &&
        customQueryErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          customQueryDataError:
            customQueryErrorResponse.data.Errors.length > 1
              ? customQueryErrorResponse.data.Errors
              : customQueryErrorResponse.data.Errors[0],
        };
      }
      return {
        ...state,
        customQueryDataError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching custom query data. Please try again.',
        },
      };

    case types.CATEGORY_SAVE_SUCCESS: {
      return {
        ...state,
        categorySaveSuccess: true,
      };
    }

    case types.CUSTOM_QUERY_SET_NEW_CATEGORY: {
      return {
        ...state,
        newCategory: action.payload,
      };
    }

    case types.CATEGORY_SAVE_ERROR:
      const customQueryCategoryResponse = action.payload.response;
      if (
        _.has(customQueryCategoryResponse, 'data.Errors') &&
        customQueryCategoryResponse.data.Errors.length
      ) {
        return {
          ...state,
          categorySaveError:
            customQueryCategoryResponse.data.Errors.length > 1
              ? customQueryCategoryResponse.data.Errors
              : customQueryCategoryResponse.data.Errors[0],
        };
      }
      return {
        ...state,
        categorySaveError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while saving category. Please try again.',
        },
      };

    case types.CATEGORY_DELETE_ERROR:
      const customQueryCategoryDeleteResponse = action.payload.response;
      if (
        _.has(customQueryCategoryDeleteResponse, 'data.Errors') &&
        customQueryCategoryDeleteResponse.data.Errors.length
      ) {
        return {
          ...state,
          categoryDeleteError:
            customQueryCategoryDeleteResponse.data.Errors.length > 1
              ? customQueryCategoryDeleteResponse.data.Errors
              : customQueryCategoryDeleteResponse.data.Errors[0],
        };
      }
      return {
        ...state,
        categoryDeleteError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while deleting category. Please try again.',
        },
      };

    case types.CUSTOM_QUERY_DELETE_SUCCESS: {
      return {
        ...state,
        customQueryDeleteSuccess: true,
      };
    }
    case types.CUSTOM_QUERY_CATEGORY_DELETE_SUCCESS: {
      return {
        ...state,
        customQueryCategoryDeleteSuccess: true,
      };
    }
    case types.CUSTOM_QUERY_SAVE_SUCCESS: {
      return {
        ...state,
        customQuerySaveSuccess: true,
      };
    }

    case types.CUSTOM_QUERY_DELETE_ERROR:
      const customQueryDeleteErrorResponse = action.payload.response;
      if (
        _.has(customQueryDeleteErrorResponse, 'data.Errors') &&
        customQueryDeleteErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          customQueryDeleteError:
            customQueryDeleteErrorResponse.data.Errors.length > 1
              ? customQueryDeleteErrorResponse.data.Errors
              : customQueryDeleteErrorResponse.data.Errors[0],
        };
      }
      return {
        ...state,
        customQueryDeleteError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while deleting query. Please try again.',
        },
      };

    case types.CLEAR_QUERY_ERROR:
      return {
        ...state,
        categoryDeleteSuccess: false,
        categorySaveSuccess: false,
        querySaveError: null,
        queryExecuteSuccess: false,
        queryExecuteError: null,
        categoryDeleteError: null,
        categorySaveError: null,
        customQueryDownloadError: null,
        customQueryDeleteError: null,
        customQueryDeleteSuccess: false,
        customQueryCategoryDeleteSuccess: false,
        customQuerySaveSuccess: false,
      };

    case types.CUSTOM_QUERY_SAVE_ERROR: {
      const customQuerySaveErrorResponse = action.payload.response;
      if (
        _.has(customQuerySaveErrorResponse, 'data.Errors') &&
        customQuerySaveErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          querySaveError:
            customQuerySaveErrorResponse.data.Errors.length > 1
              ? customQuerySaveErrorResponse.data.Errors
              : customQuerySaveErrorResponse.data.Errors[0],
        };
      }
      return {
        ...state,
        querySaveError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while deleting query. Please try again.',
        },
      };
    }

    case types.CUSTOM_QUERY_DOWNLOAD_ERROR:
      const customQueryDownloadErrorResponse = action.payload.response;
      if (
        _.has(customQueryDownloadErrorResponse, 'data.Errors') &&
        customQueryDownloadErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          customQueryDownloadError:
            customQueryDownloadErrorResponse.data.Errors.length > 1
              ? customQueryDownloadErrorResponse.data.Errors
              : customQueryDownloadErrorResponse.data.Errors[0],
        };
      }
      return {
        ...state,
        customQueryDownloadError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while downloading query. Please try again.',
        },
      };

    case types.CUSTOM_QUERY_EXECUTE_SUCCESS: {
      return {
        ...state,
        queryExecuteSuccess: true,
      };
    }
    case types.CUSTOM_QUERY_EXECUTE_ERROR: {
      const customQueryErrorErrorResponse = action.payload.response;
      if (
        _.has(customQueryErrorErrorResponse, 'data.Errors') &&
        customQueryErrorErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          queryExecuteError:
            customQueryErrorErrorResponse.data.Errors.length > 1
              ? customQueryErrorErrorResponse.data.Errors
              : customQueryErrorErrorResponse.data.Errors[0],
        };
      }
      return {
        ...state,
        queryExecuteError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while deleting query. Please try again.',
        },
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/customQueries/reducer.js